
import { UserAdminPageType } from '../../../Constants/Types';
import { compareBooleans, compareDates, compareStrings } from 'src/Util/TableComparers';

export const compareUsers = (a: UserAdminPageType, b: UserAdminPageType, sortBy: string): number => {
    const withSecondary = (primary: number) => {
        if (primary !== 0) return primary;
        return compareStrings(a.username, b.username);
    }

    switch (sortBy) {
        case 'username':
            return compareStrings(a.username, b.username);

        case 'organization':
            return withSecondary(
                compareStrings(a.organizationName, b.organizationName)
            );

        case 'role':
            return withSecondary(
                compareStrings(a.roles?.[0], b.roles?.[0])
            );

        case 'lastActive':
            return withSecondary(
                compareDates(a.lastActive, b.lastActive)
            );

        case 'status':
            return withSecondary(
                compareBooleans(a.enabled, b.enabled)
            );

        case 'lastJoinedCourse':
            return withSecondary(
                compareStrings(a.lastJoinedGroupName, b.lastJoinedGroupName)
            );

        case 'nationality':
            return withSecondary(
                compareStrings(a.nationality, b.nationality)
            );

        default:
            return 0;
    }
}